import { useWeb3React } from '@web3-react/core'
import { ButtonPurple } from 'components/Button'
import Row from 'components/Row'
import { useCallback } from 'react'
import { useTransactionAdderWithCallback } from 'state/transactions/hooks'
import { TransactionType } from 'state/transactions/types'

import { useCompetitionContract } from '../../../../hooks/useContract'
import { nowInSeconds } from '../../../../utils/date'
import { agent } from '../../api/agent'
import { SignTaskReq } from '../../api/interfaces/sign-task.interface'
import { useStatus } from '../../hooks/useStatus'

interface ITwitterConnect {
  confirmTask: (data: { id: number; wallet: string }) => Promise<void>
}

export function TwitterConnect({ confirmTask }: ITwitterConnect) {
  const buttonStatus = useStatus()
  const { account, provider } = useWeb3React()
  const competitionContract = useCompetitionContract()
  const addTransactionWithCb = useTransactionAdderWithCallback()

  const handleConnect = useCallback(async () => {
    if (!provider || !account || !competitionContract) return
    let signature
    const timestamp = nowInSeconds()
    const signTaskReq: SignTaskReq = { id: 1, timestamp, url: '' }

    buttonStatus.setPending()
    try {
      signature = await provider.getSigner().signMessage(JSON.stringify(signTaskReq))
    } catch (e) {
      console.warn(e)
      buttonStatus.setError()
      return
    }
    const res = await agent.competition.signTask(account, signTaskReq, signature)
    console.log(7777, res)

    let hash
    try {
      hash = await competitionContract.updateUserMultiplier(res.multiplier, res.id, res.start, res.end, res.signature)
      await confirmTask({ id: +res.id, wallet: account })
    } catch (e) {
      console.warn(e)
      buttonStatus.setError()
      return
    }

    buttonStatus.setSuccess()
    addTransactionWithCb(hash, {
      type: TransactionType.TASK,
      taskName: '1',
    })
  }, [account, provider])
  return (
    <div>
      <ul style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingLeft: '20px' }}>
        <li>By connecting your Twitter account, you will get extra multiplier on your trades.</li>
      </ul>

      <Row justify="center">
        <ButtonPurple
          style={{ padding: '9px 20px', width: 'auto' }}
          onClick={handleConnect}
          disabled={buttonStatus.isPending}
        >
          Verify & Connect
        </ButtonPurple>
      </Row>
    </div>
  )
}
